import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { CirclesInterface } from '../../widget-photos-teaser-circle.props';
import SrcSet from '../../../../../components/src-set/src-set';
import getLinkRelByTarget from 'helpers/get-link-rel-by-target';

import './widget-photos-teaser-circle-circles.scss';

interface WidgetPhotosTeaserCircleCirclesInterface {
    circles: CirclesInterface[];
}

const WidgetPhotosTeaserCircleCircles: React.FC<WidgetPhotosTeaserCircleCirclesInterface> = ({ circles }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    return (
        <div className="circles">
            <div className="circles__list">
                { circles.map((item, idx) => (
                    <a
                        className="circles__list__item"
                        href={item.url}
                        key={item.img}
                        target={item.target}
                        rel={getLinkRelByTarget(item.target)}
                    >
                        <div className="circles__list__item__main">
                            <div className="circles__list__item__image">
                                <picture>
                                    <SrcSet
                                        images={item.modifiedImg}
                                        alt={item.title.trim() || `Obrazek ${idx}`}
                                        isMobile={isMobile}
                                    />
                                </picture>
                            </div>
                        </div>
                        <div className="circles__list__item__text">
                            {item.title}
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default WidgetPhotosTeaserCircleCircles;
